import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { POSTHOG_ENABLED, posthogService } from 'src/common/services/posthogService';

/**
 * Tracks SPA pageviews in PostHog on route changes.
 * Must be rendered inside <BrowserRouter>.
 *
 * - Fires `$pageview` on initial mount
 * - Fires `$pageview` on every pathname change
 * - Fires `$pageleave` on cleanup (before the next route renders)
 * - Skips duplicate `$pageview` fires for query-only or hash-only changes
 */
export const PostHogPageViewTracker = () => {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!POSTHOG_ENABLED) return;

    // Fire on initial mount and on pathname changes (skip query-only changes)
    if (location.pathname !== prevPathRef.current) {
      posthogService.capturePageview();
      prevPathRef.current = location.pathname;
    }

    // Fire $pageleave when navigating away so PostHog can calculate time-on-page
    return () => {
      posthogService.capturePageleave();
    };
  }, [location]);

  return null;
};
